export default "__VITE_ASSET__CfuMbiR2__"